import UserModule from './UserModule';

export default UserModule;
